/**
* @name: main-page
* @author: weiyong
* @date: 2022-10-26 19:34
* @description：main-page
* @update: 2022-10-26 19:34
*/
<template>
  <div class="w100b h100b main-page desCtl rootDrage"
       id="page"
       ref="pageRootRef"
       :data-label="t('页面')"
       :style="pageStyle"
       :class="computedClasses"
  >
    <template class="w100b" v-for="(outElement,index) in pageConfig.blocks" :key="getElementKey(outElement)">
      <component :elConfig="outElement"
                 class="desCtl"
                 v-if="outElement.componentKey"
                 :data-label="outElement.label"
                 :flowDealType="flowDealType"
                 :props="outElement.props"
                 :dataConfig="outElement.dataConfig"
                 :styles="outElement.styles"
                 :pModelObj="(outElement.componentKey==='xmForm'&&pageFrom==='xmPageContent')?pModelObj:state"
                 :pConfigs="{componentKey:'page'}"
                 :showLabel="outElement.props.showLabel"
                 :id="outElement.key"
                 :model="outElement.model"
                 :events="outElement.events"
                 :is="outElement.componentKey + 'Ctl'"/>

    </template>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import allCtls from './ctls/allCtls';

export default defineComponent({
  components: {
    ...allCtls,
  },
  name: "main-page",
});
</script>

<script lang="ts" setup>
import {useI18n} from 'vue-i18n';
import {debounce} from "lodash-es";
import {useLayoutSty} from "@/main-page/hooks/useLayoutSty";
import {defineProps} from "vue";
import {useCtlOperation} from "@/main-page/hooks/useCtlOperation";
import {executeFlushActiveState} from "@/visual-editor/eventUtils";
import {usePageModelsStore} from "@/store/modules/pageModels";
import {getStyJson} from "@/main-page/utils/styleUtils";
import {storeToRefs} from "pinia";
import GoingUtils from "@/utils/goingUtils";
import NProgress from "nprogress";

const {t} = useI18n();
const pageModelsStore: any = usePageModelsStore();
const {state} = storeToRefs(pageModelsStore);

const props = defineProps({
  pageFrom: {
    type: String,
    default: ''
  },
  flowDealType: {
    type: String,
    default: ''
  },
  pModelObj: {
    type: Object,
    default: () => {
      return null;
    }
  },
  pageConfig: {
    type: Object,
    default: () => ({})
  }
})
const {pageConfig}: any = toRefs(props);
const emit = defineEmits(['clickCtlItem']);
const pageRootRef = ref(null);
provide('pageConfig', pageConfig);
provide('pageRootRef', pageRootRef);

/**
 * 页面style信息
 */
const pageStyle = computed(() => {
  const {styles = {}, props = {}} = unref(pageConfig);
  const sty = {};
  getStyJson(sty, unref(styles), props);
  if (unref(props)["src"]) {
    // 对背景图片URL进行安全处理
    const imgUrl = unref(props)["src"].replace(/['"`]/g, ''); // 移除引号字符
    sty["background"] = `url(${imgUrl}) center center / 100% 100% no-repeat`;
  }
  if (unref(props)["align"]) {
    sty["text-align"] = unref(props)["align"];
  }
  return unref(sty);
})
const pageCode:any=GoingUtils.getPageCode();
/**
 * 计算页面类名
 */
const computedClasses = computed(() => {
  const classes = [
    unref(pageCode) || '',
    pageConfig.value?.configs?.props?.pageClassName || '',
    pageConfig.value?.configs?.props?.pageTheme || '',
    pageConfig.value?.props?.fixWidth ? 'fixWidth' : '',
    pageConfig.value?.blocks && pageConfig.value.blocks.length > 0 ? 'hasChildren' : ''
  ];
  
  return classes.filter(className => className !== '');
});

/**
 * 获取元素key值
 */
const getElementKey = (element) => {
  // 确保每个元素都有一个唯一的key
  return element.key || element.id || JSON.stringify(element);
};

/**
 * 操作相关
 */
const {delRow, getOperationSty} = useCtlOperation();
const {layoutSty} = useLayoutSty();

const scrollChange = debounce(function () {
  executeFlushActiveState();
})

let mainPageEl = null;

onMounted(() => {
  nextTick(() => {
    mainPageEl = document.querySelector(".main-page");
    if (mainPageEl) {
      // 尾部的 true 最好加上，我这边测试没加 true ，拖拽滚动条无法监听到滚动，加上则可以监听到拖拽滚动条滚动回调
      mainPageEl.addEventListener('scroll', scrollChange, true);
    }
  })
})

onUnmounted(() => {
  // 移除事件监听器防止内存泄漏
  if (mainPageEl) {
    mainPageEl.removeEventListener('scroll', scrollChange, true);
  }
})

onActivated(()=>{
  setTimeout(()=>{
    NProgress.done();
  },300)
})
</script>

<style type="text/css" lang="less">
@import "./less/mainPage.less";


.\!min-h-680px {
  min-height: 680px !important;
}
</style>
